exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Root___1SOz8 {\n  background-color: var(--color-forget-badge);\n}\n", ""]);

// exports
exports.locals = {
	"Root": "Root___1SOz8"
};